import countries from '../countries';
import { COUNTRY_TYPE_ADDRESS } from '../Address/addressUtils/addressConstants';

export const CountryUtil = {
  filterCountres: (countries, removeCountries, type, propType) => {
    removeCountries.map(country => country !== countries);
    const filteredCountries = countries.filter(
      country => removeCountries.indexOf(country[type]) < 0
    );
    const filteredOptions = filteredCountries.map(country => ({
      id: propType === COUNTRY_TYPE_ADDRESS ? country[type] : country.code,
      labelText: country[type] || country.name
    }));
    return filteredOptions;
  },

  getValueForCountryCode: code => {
    const country = countries.filter(v => v.code === code);
    return country && country.length > 0 ? country[0].name : '';
  },

  getNationalityForCountryCode: code => {
    const country = countries.filter(v => v.code === code);
    return country && country.length > 0 ? country[0].nationality || country[0].name : '';
  },

  getValueForCountryName: name => {
    const country = countries.filter(
      v => v.name && name && v.name.toLowerCase() === name.toLowerCase()
    );
    return country && country.length > 0 ? country[0].code : '';
  },

  getValueForCountryNationality: (nationality, name) => {
    const country = countries.filter(
      v =>
        nationality &&
        v.nationality &&
        name &&
        v.nationality.toLowerCase() === nationality.toLowerCase() &&
        v.name.toLowerCase() === name.toLowerCase()
    );
    return country && country.length > 0 ? country[0].code : '';
  },

  getValueForPrimaryCustNationality: nationality => {
    let custNationality = countries.filter(
      v => nationality && v.name && v.name.toLowerCase() === nationality.toLowerCase()
    );
    if (custNationality && custNationality.length === 0) {
      custNationality = countries.filter(
        v =>
          nationality && v.nationality && v.nationality.toLowerCase() === nationality.toLowerCase()
      );
    }
    return custNationality && custNationality.length > 0 ? custNationality[0].code : '';
  }
};
